import React from 'react';
import { HiBars3, HiXMark } from 'react-icons/hi2';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';
import DarkModeToggle from './DarkModeToggle';
import { useApp } from '../context/AppContext';

const Header = ({ sidebarOpen, setSidebarOpen }) => {
  const { t } = useTranslation();
  const { preferences } = useApp();
  const isDark = preferences.darkMode || false;

  return (
    <header className="bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-700 fixed top-0 left-0 right-0 z-50 no-print">
      <div className="px-4 py-4 md:px-6">
        <div className="flex items-center justify-between">
          {/* Mobile menu button */}
          <button
            type="button"
            className="md:hidden p-1.5 rounded-md text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 focus:outline-none focus:ring-1 focus:ring-teal-500 mr-2"
            onClick={() => setSidebarOpen(!sidebarOpen)}
            aria-label={t('common.menu')}
          >
            {sidebarOpen ? (
              <HiXMark className="h-5 w-5" aria-hidden="true" />
            ) : (
              <HiBars3 className="h-5 w-5" aria-hidden="true" />
            )}
          </button>

          {/* Logo and title */}
          <div className="flex items-center gap-3 flex-1 md:flex-initial ml-2 md:ml-0">
            <div className="flex-shrink-0">
              <img 
                src={isDark ? '/FPRA dark mode.png' : '/FPRA white mode.png'}
                alt="FPRA Logo" 
                className="h-10 w-auto object-contain"
              />
            </div>
            <div className="hidden sm:block">
              <h1 className="text-lg font-bold text-gray-900 dark:text-white">FPRA</h1>
              <p className="text-xs text-gray-600 dark:text-gray-400 whitespace-nowrap">{t('header.subtitle')}</p>
            </div>
          </div>

          {/* Controls */}
          <div className="flex items-center gap-2 flex-shrink-0">
            <DarkModeToggle />
            <LanguageSwitcher />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
